import { Card, CardBody } from "@theg1group/ui";
import type { ReactNode } from "react";

export function KpiTile({
	label,
	value,
	hint,
	tone,
}: {
	label: string;
	value?: ReactNode;
	hint?: ReactNode;
	tone?: "default" | "danger" | "warning" | "success";
}) {
	const color =
		tone === "danger"
			? "text-danger"
			: tone === "warning"
				? "text-warning"
				: tone === "success"
					? "text-success"
					: "text-content";
	return (
		<Card>
			<CardBody>
				<div className="text-[11px] uppercase text-muted">{label}</div>
				<div className={`text-2xl font-bold ${color}`}>{value ?? "—"}</div>
				{hint && <div className="text-[11px] text-muted">{hint}</div>}
			</CardBody>
		</Card>
	);
}
